import { TaggedError } from "@for-it/domain-lib";
export class AccountDisabledError extends TaggedError {
    constructor() {
        super("AccountDisabledError");
    }
}
